import script from "./IndividualCalls.vue?vue&type=script&setup=true&lang=js"
export * from "./IndividualCalls.vue?vue&type=script&setup=true&lang=js"

import "./IndividualCalls.vue?vue&type=style&index=0&id=1a8d9df8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8d9df8"]])

export default __exports__